"use strict";

import { isBrowser } from "./common";

class IframeReceiver {
  constructor(allowedOrigin, id, iframe) {
    this.id = id;
    this.iframe = iframe;
    this.allowedOrigin = allowedOrigin;
    this.type = "iframeSync";
    this.width = 0;
    this.height = 0;

    this.init();
  }

  init() {
    console.log("IframeReceiver initialized");

    window.addEventListener("message", this.handleMessage.bind(this));
  }

  handleMessage(event) {
    const isSameOrigin = event.origin === this.allowedOrigin;

    if (!isSameOrigin) {
      console.warn("Origin not allowed:", event.origin);
      return;
    }

    if (typeof event.data !== "object") {
      console.warn("Invalid data:", event.data);
      return;
    }

    const { width, height, id, type } = event.data;

    if (type !== this.type) return;

    if (width && !isNaN(width) && height && !isNaN(height) && id === this.id) {
      this.updateIframeDimensions(width, height, id);
    }
  }

  updateIframeDimensions(width, height, id) {
    const iframe = document.querySelector(`#${id}`);
    if (iframe) {
      iframe.style.height = `${height}px`;
    } else {
      console.warn(`Iframe with id ${id} not found`);
    }
  }

  sendMessage(message) {
    window.frames[this.id]?.contentWindow.postMessage(
      message,
      this.allowedOrigin,
    );
  }

  destroy() {
    window.removeEventListener("message", this.handleMessage);
  }
}

function onDocumentReady() {
  const origin = window.location.origin;
  const iframesList = document.querySelectorAll("iframe");

  iframesList.forEach((iframe, index) => {
    const hasId = iframe.hasAttribute("id");
    const id = hasId ? iframe.id : `iframe-${index}`;

    if (!hasId) {
      // Iframes with ID are handled by external library
      iframe.setAttribute("id", id);
      iframe.setAttribute("scrolling", "no");
      iframe.style.overflow = "hidden";

      new IframeReceiver(origin, id, iframe);

      iframe.addEventListener("unload", () => {
        receiver.destroy();
      });
    }
  });
}

if (document.readyState !== "loading") {
  onDocumentReady();
} else {
  document.addEventListener("DOMContentLoaded", () => {
    if (isBrowser) {
      onDocumentReady();
    }
  });
}
